import {useEffect, useState} from 'react'
import {BASE_URL} from '../../../api'
import config from '../../config'
const {axios} = config

// AI features (roadmap #17): this month's estimated spend vs the monthly
// budget set on the server (AI_MONTHLY_BUDGET_USD). When the budget is
// reached, all AI features switch off automatically until the 1st.
const AiUsage = () => {
  const [d, setD] = useState(null)
  const [error, setError] = useState('')
  useEffect(() => {
    axios
      .get(`${BASE_URL}/admin/ai-usage`)
      .then(({data}) => setD(data.data))
      .catch(() => setError('Could not load AI usage.'))
  }, [])
  const pct = d ? Math.min(100, Math.round((d.spentUsd / (d.budgetUsd || 1)) * 100)) : 0
  return (
    <div className='card mb-5'>
      <div className='card-body p-9'>
        <h3 className='fw-bolder mb-3'>AI usage</h3>
        <p className='text-muted'>
          Estimated cost of the app's AI features this month. When it reaches the monthly budget,
          every AI feature switches off automatically until the 1st of next month - the app simply
          hides the AI buttons. Your Anthropic account's prepaid credit is a second hard limit.
        </p>
        {error && <div className='alert alert-danger py-3'>{error}</div>}
        {!d && !error && <div className='text-muted'>Loading…</div>}
        {d && (
          <>
            {!d.enabled && <div className='alert alert-warning py-3'>AI is not set up on the server yet (no API key).</div>}
            <div className='fs-2 fw-bolder'>
              ${d.spentUsd.toFixed(2)} <span className='fs-5 text-muted fw-normal'>of ${d.budgetUsd.toFixed(2)} budget ({d.month})</span>
            </div>
            <div className='progress h-10px my-4' style={{maxWidth: 500}}>
              <div className={`progress-bar ${pct >= 90 ? 'bg-danger' : pct >= 70 ? 'bg-warning' : 'bg-success'}`} style={{width: `${pct}%`}} />
            </div>
            <div className='text-muted'>{d.calls} AI requests this month</div>
          </>
        )}
      </div>
    </div>
  )
}

export default AiUsage
